// Ссылки-приглашения (contracts/api.md, «Ссылки-приглашения»). Токен стоит в адресе:
// в журнал запросов он не пишется, ответы — с Referrer-Policy: no-referrer (FR-003д).
import { z } from '../kernel/zod.ts';
import { InvitePurposeSchema } from '../access/user.ts';
import { TimestampSchema } from '../kernel/common.ts';
import { fieldMessages } from '../kernel/field-messages.ts';
import { AuthSettingsSchema, PASSWORD_MAX_LENGTH } from './auth.ts';

/** Токен — 32 случайных байта в base64url (43 знака); формат проверяется мягко. */
export const InviteTokenParamsSchema = z.object({
  token: z.string().regex(/^[A-Za-z0-9_-]{16,128}$/),
});

/**
 * GET /api/invites/{token}: без ФИО (FR-016б). Пояс — для срока ссылки, значения защиты входа —
 * для подсказки к паролю: страница ссылки работает без сеанса и /api/auth/me (принцип VIII).
 */
export const InviteInfoSchema = z.object({
  purpose: InvitePurposeSchema,
  /** m*****v@example.ru */
  emailMasked: z.string(),
  expiresAt: TimestampSchema,
  /** Часовой пояс установки: Asia/Yekaterinburg. */
  timeZone: z.string(),
  settings: AuthSettingsSchema,
});
export type InviteInfo = z.infer<typeof InviteInfoSchema>;

/** POST /api/invites/{token}/accept: правила пароля проверяет сервер (AUTH-007). */
export const AcceptInviteBodySchema = z.object({
  password: z
    .string({ error: fieldMessages.password })
    .min(1, { error: fieldMessages.password })
    .max(PASSWORD_MAX_LENGTH, { error: fieldMessages.password }),
});
export type AcceptInviteBody = z.input<typeof AcceptInviteBodySchema>;
